import * as yup from "yup";
import stripHtml from "../../../utils/StripHtml";

export const schema = yup.object().shape({
    // id: yup.number().optional(),
    comment: yup
        .string()
        .required('Comentário é obrigatório')
        .test('hasText', 'Comentário é obrigatório', (v) => stripHtml(v ?? '').length > 0)
        .test(
            'minWords',
            'Escreva pelo menos 3 palavras',
            (v) => stripHtml(v ?? '').split(/\s+/).filter(Boolean).length >= 3
        ),
});